import { useSuspenseQuery as e } from "@tanstack/react-query";
//#region src/hooks/useSuspenseQuery.ts
function t(t) {
	return e(t);
}
//#endregion
export { t as useSuspenseQuery };
